<div class="page">
  <div class="container">

    <h1>About DailyCity</h1>

    <p>
      DailyCity is an independent city-focused information platform created
      to provide reliable daily updates for major Indian cities.
    </p>

    <p>
      Our platform brings together essential information such as petrol and
      diesel prices, gold and silver rates, power cut updates, traffic
      conditions and Panchang timings in one easy-to-access place.
    </p>

    <p>
      DailyCity is designed for residents, professionals and households who
      depend on timely city updates to plan their daily activities efficiently.
    </p>

    <p>
      We continuously work to improve content accuracy, usability and overall
      user experience while keeping the platform simple and accessible.
    </p>

    <h2>Our Purpose</h2>
    <p>
      The purpose of DailyCity is to reduce the effort required to find daily
      city information from multiple sources by presenting it in a clear,
      structured and user-friendly format.
    </p>

  </div>
</div>
